import { defineMessages } from 'react-intl';

export const messages: {
	searchLinkLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchLinkLabel: {
		id: 'search-page.search-link.label',
		defaultMessage: 'Search Link',
		description: 'Aria label for search link result',
	},
});
